<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>
                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-gradient-to-b from-pitch-purple to-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                Invoice Service Lines
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="py-6 px-4 sm:px-6">
                                        <div class="flex gap-4">
                                            <table class="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead class="bg-gray-50">
                                                    <tr>
                                                        <th scope="col" class="relative w-12 px-6 sm:w-16 sm:px-8"></th>
                                                        <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Folder</th>
                                                        <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Supplier</th>
                                                        <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Item</th>
                                                        <th scope="col" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="divide-y divide-gray-200 bg-white">
                                                    <tr class="bg-gray-50">
                                                        <td></td>
                                                        <td colspan="4" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                                            Existing Selected
                                                        </td>
                                                    </tr>
                                                    <tr v-for="quote_service in invoice.quote_services">
                                                        <td class="relative w-12 px-6 sm:w-16 sm:px-8">
                                                            <div class="absolute inset-y-0 left-0 w-0.5 bg-pitch-purple"></div>
                                                            <input type="checkbox" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-pitch-purple focus:ring-indigo-500 sm:left-6" :value="quote_service.id" v-model="form.quote_service_ids"/>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="quote_service.folder">{{ quote_service.folder.name }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="quote_service.supplier">{{ quote_service.supplier.name }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="quote_service.name">{{ quote_service.name }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="quote_service.buy_gross_total">£{{ parseFloat(quote_service.buy_gross_total).toFixed(2) }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                    </tr>
                                                    <tr class="bg-gray-50">
                                                        <td></td>
                                                        <td colspan="4" class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                                            Unassigned Service Lines
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(service_line, index) in service_lines">
                                                        <td class="relative w-12 px-6 sm:w-16 sm:px-8">
                                                            <div class="absolute inset-y-0 left-0 w-0.5 bg-pitch-purple"></div>
                                                            <input type="checkbox" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-pitch-purple focus:ring-indigo-500 sm:left-6" :value="service_line.id" v-model="form.quote_service_ids"/>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="service_line.folder">{{ service_line.folder.name }}</span>
                                                            <span v-else>N/A</span>

                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="service_line.supplier">{{ service_line.supplier.name }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="service_line">{{ service_line.name }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium">
                                                            <span v-if="service_line">£{{ parseFloat(service_line.buy_gross_total).toFixed(2) }}</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <br />
                                        <div class="flex-shrink-0 flex justify-end">
                                            <button type="submit"
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 w-full">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, computed} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {emitter} from "@/eventHub";
import {useForm, usePage} from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";
import axios from 'axios';
import ServiceLines from "@/Components/ServiceLines.vue";


export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XIcon,
        ServiceLines
    },
    setup() {
    },
    data() {
        return {
            show: ref(false),
            showErrors: ref(false),
            form: {}
        }
    },
    methods: {
        open(invoice) {
            console.log(invoice);
            this.service_lines = [];
            this.invoice = invoice;
            this.quote = this.invoice.quote;
            this.fixture_id = this.quote.fixture_id;
            var vm = this;
            this.fetchServiceLines(function(){
                vm.show = true;
                vm.form = useForm({
                    quote_service_ids: vm.invoice.quote_service_ids
                });
            });
        },
        close() {
            this.show = false;
        },
        submit() {
            this.form.post(route('frontend.invoices.add-service-lines', [this.invoice]), {
                onSuccess: page => {
                    this.show = false;
                    this.form.reset();
                }
            });
        },
        fetchServiceLines(callback) {
            axios.get(route('frontend.invoices.get-service-lines', this.invoice)).then(response => {
                this.service_lines = response.data.service_lines;
                callback(true);
            });
        }
    },
    mounted() {
        emitter.on('addServiceLines', (invoice) => {
            this.open(invoice);
        })
    }
}
</script>
